import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const MeetAndGreetIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className} `;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="meet-grate-icon"
      viewBox="0 0 16 16"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.00065C0 2.52789 1.19391 1.33398 2.66667 1.33398H13.3333C14.8061 1.33398 16 2.52789 16 4.00065V12.0007C16 13.4734 14.8061 14.6673 13.3333 14.6673H2.66667C1.19391 14.6673 0 13.4734 0 12.0007V4.00065ZM2.66667 2.66732H13.3333C14.0697 2.66732 14.6667 3.26427 14.6667 4.00065V12.0007C14.6667 12.737 14.0697 13.334 13.3333 13.334L10 13.334V8.26732C10.4 8.13398 10.8 7.93398 11.1333 7.66732C12.1333 6.86732 12.6 5.73398 12.6667 4.26732V4.00065H11.3333V4.33398C11.3333 5.33398 10.9867 6.09398 10.32 6.62732C9.78667 7.02732 9.33333 7.33398 8 7.33398C6.66667 7.33398 5.47333 7.87398 4.74 8.47398C3.80667 9.27398 3.33333 10.334 3.33333 11.6673V12.0007H4.66667V11.6673C4.67333 10.6673 5 10.0673 5.6 9.60065C5.66667 9.53398 5.8 9.46732 6 9.40065V13.334L2.66667 13.334C1.93029 13.334 1.33333 12.737 1.33333 12.0007V4.00065C1.33333 3.26427 1.93029 2.66732 2.66667 2.66732ZM6.66667
        5.33398C6.66667 6.06732 7.26667 6.66732 8 6.66732C8.73333 6.66732 9.33333 6.06732 9.33333 5.33398C9.33333 4.60065 8.73333 4.00065 8 4.00065C7.26667 4.00065 6.66667 4.60065 6.66667 5.33398Z"
        fill={fill || '#7E8A96'}
      />
    </svg>
  );
};

export default MeetAndGreetIcon;
